module.exports = __webpack_public_path__ + "img/automati1.ea7b5bb5.jpg";